import ProductModel from 'coreClasses/product/ProductModel';
import ProductSearchHitModel from 'coreClasses/search/ProductSearchHitModel';
import {EAnalyticsProvider} from 'coreClasses/analytics/IAnalytics';

export enum EEventType {
	PAGE_VIEW,
	SPLASH_PAGE_VIEW,
	RECOMMENDATIONS_VIEW,
	RECOMMENDATIONS_LOADED,
	CUSTOMER_CHANGED,
	LOGS_IN,
	LOGS_OUT,
	CHANGE_LOCAL,
	CUSTOMER_REGISTRATION,
	NEWSLETTER_SUBSCRIPTION,
	PRODUCT_CLICK,
	PRODUCT_RECOMMENDATION_CLICK,
	PRODUCT_LIST_LOAD,
	PRODUCT_DETAIL_VIEW,
	PRODUCT_ADD_TO_CART,
	PRODUCT_SUGGESTION_CLICK,
	PRODUCT_REMOVE_FROM_CART,
	PRODUCT_ADD_TO_WISHLIST,
	VIEW_ITEM_LIST,
	SEARCH_QUERY,
	PROMOTION_CLICK,
	PROMOTION_VIEW,
	SELECT_BRAND_PROMOTION,
	VIEW_BRAND_PROMOTION,
	VIEW_SIZES,
	CART_UPDATED,
	WISHLIST_UPDATED,
	SIGNUP,
	CLICK_MENU,
	CLICK_IMAGE_CTA
}

export enum EEventSource {
	HOME,
	PDP,
	PLP,
	CLP,
	SP,
	ERROR,
	RETURN_ORDER,
	GIFT_CERTIFICATE,
	QUICK_SEARCH,
	SEARCH_RESULTS,
	SEARCH_PREVIEW,
	FULL_SEARCH_RESULTS,
	YOU_MAY_ALSO_LIKE,
	WEAR_THIS_WITH,
	RECENTLY_VIEWED,
	RECOMMENDATION,
	CART,
	WISHLIST,
	MY_ACCOUNT,
	SIGN_UP,
	NEWSLETTER_POPUP,
	FOOTER,
	NOTIFY_ME_POPUP,
	CONTENTFUL_CATEGORY,
	REGISTER_USER,
	SIZE_SELECTOR,
	ADD_TO_CART,
	NEWSLETTER_PAGE,
	NEWSLETTER_FORM,
	WAITINGLIST_NEWSLETTER,
	COMPLETE_THE_SET,
	POPUP,
	STYLE_THIS_WITH,
	VIRTUAL_TRY_ON,
	MATCH_IT_WITH,
	SHOP_THE_LOOK,
	OTHER
}

export interface IPageData {
	pageType: EEventSource;
	pageSpecificData?: {
		[key: string]: any;
	};
	siteSection?: string | undefined;
	dataLayerObj?: {
		[key: string]: any;
	};
	pageViewCounter?: number;
	isPageInitialized?: boolean;
	onLoad?: () => void;
}

export interface IEventData {
	[key: string]: any;
	options?: {
		excludeFromAnalytics?: EAnalyticsProvider[];
	};
}

export interface IEventProductData {
	product?: ProductModel;
	attributes?: {
		[key: string]: any;
	};
	productHit?: ProductSearchHitModel;
	position?: number;
	variationGroupIdForCartEvents?: boolean;
}

export enum EComponentSource {
	SSS_Tile = 'SSS_Tile', //Product Tiles on PLP and Search Results (Search Sub System)
	PDP = 'PDP', //Product Details Page
	QV = 'QV', //Quick View
	RSS = 'RSS', //Recommendations
	RV = 'RV', //Recently Viewed
	MCS = 'MCS', //Mini Cart
	MCP = 'MCP', //Mini Cart Flyout
	MAO = 'MAO', //My Account Orders
	MAW = 'MAW', //My Account Wishlist
	CO = 'CO', //Checkout
}

export const sourceMappings = {
	[EEventSource.HOME]: EComponentSource.SSS_Tile,
	[EEventSource.PDP]: EComponentSource.PDP,
	[EEventSource.PLP]: EComponentSource.SSS_Tile,
	[EEventSource.CLP]: EComponentSource.SSS_Tile,
	[EEventSource.SP]: EComponentSource.SSS_Tile,
	[EEventSource.SEARCH_RESULTS]: EComponentSource.SSS_Tile,
	[EEventSource.RECENTLY_VIEWED]: EComponentSource.RV,
	[EEventSource.RECOMMENDATION]: EComponentSource.RSS,
	[EEventSource.CART]: EComponentSource.MCS,
	[EEventSource.WISHLIST]: EComponentSource.MAW,
	[EEventSource.WEAR_THIS_WITH]: EComponentSource.RSS,
	[EEventSource.STYLE_THIS_WITH]: EComponentSource.RSS,
	[EEventSource.SHOP_THE_LOOK]: EComponentSource.RSS,
	[EEventSource.OTHER]: EComponentSource.RSS
};
